import {outter_post,post} from 'common/js/axios-helper';
import {ChannelRateApi, OrganApi} from "./constant/UrlMapper";



const host = '8880';

const getByChn = (data) => {
    return post(ChannelRateApi.GetByChn, data, host);
};


export default {getByChn}



// WEBPACK FOOTER //
// ./src/service/ChannelRateService.js